/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Images
import panel_mockup from '../../assets/images/panel/mockup_curved.svg';

const Panel = () => {
    return (
        <section className="panel py-28 max-w-8xl mx-auto px-5 sm:px-5 lg:px-5">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 items-center">
                <div>
                    <img src={panel_mockup} className="w-full" alt="Panel Image" />
                </div>
                <div>
                    <h1 className="text-gray-100 font-semibold text-3xl mb-7">We call it Cyperpanel</h1>
                    <p className="text-gray-300 mb-9">We offer a highly customized version of the Pterodactyl control panel. Managing your server is incredibly easy and all of our features are intuitive and well documeneted.</p>
                    <ul>
                        <li className="flex items-center pb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-primary h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="text-gray-200 text-lg font-medium ml-5">Manage your Server</p>
                        </li>
                        <li className="flex items-center pb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-primary h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="text-gray-200 text-lg font-medium ml-5">Full FTP File Access</p>
                        </li>
                        <li className="flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="text-primary h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="text-gray-200 text-lg font-medium ml-5">Access your Console & Chat</p>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default Panel